// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"34b15129","703":"b2c050e5"}[chunkId] + ".chunk.js";
};